import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import DropDown from '@/components/profile/dropDown'
import RoundBlueButton from '@/components/profile/roundBlueButton'
import { listOfSections } from "@/pages/profile/sections/bssDetails/constants"

import '@/pages/profile/sections/common.css'

export default function BloodGroup(props: any) {
    const { profile } = useLocalTranslation();
    const bloodGrpOptions = [
        {
            value: "A+",
            label: "A+"
        },
        {
            value: "A-",
            label: "A-"
        },
        {
            value: "B+",
            label: "B+"
        },
        {
            value: "B-",
            label: "B-"
        },
        {
            value: "AB-",
            label: "AB-"
        },
        {
            value: "AB+",
            label: "AB+"
        },
        {
            value: "O+",
            label: "O+"
        },
        {
            value: "O-",
            label: "O-"
        }
    ];

    return (
        <div className='profileSectionOfSectionCommonMainCon'>

            <div className='commonCon1'>
                <ul className='list-disc list-inside'>
                    {profile.bssSection.notes.n1.map((n: string, index: number) => (
                        <li key={index}>{n}</li>
                    ))}
                </ul>
            </div>

            <p className='commonH2'>
                {profile.fields.bloodGroup}
                <span className='text-[#FF2828]'>*</span>
            </p>

            {props.errMsg !== "" &&
                <p className='commonErr1'>{props.errMsg}</p>
            }

            <DropDown
                options={bloodGrpOptions}
                value={props.value}
                onChange={(e: any) => props.handleInputChange(e, listOfSections.bloodGroup)}
                placeholder={profile.placeHolders.bloodGroup}
                customDropDownIcon={true}
            />

            <div className='commonBtnCon1'>
                <RoundBlueButton
                    disabled={props.isSubmitBtnLoading}
                    onClick={() => props.handleSubmit(listOfSections.bloodGroup)}
                />
            </div>
        </div>
    );
}
